import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import { createFragmentContainer } from 'react-relay';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { TableContainer, Table,  TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { format } from 'date-fns';

const styleSheet = theme => ({
    paper: {
      width: '100%',
      marginTop: theme.spacing(1),
      overflow: 'auto',
    },
    tblHead: {
      backgroundColor: '#f1f1f1',
    },
    tblHeadRow: {
      height: 32,
    },
    tblHeadCell: {
      textAlign: 'center',
      verticalAlign: 'bottom',
      borderBottom: 0,
    },
    tblHeadCellRight: {
      textAlign: 'right',
      verticalAlign: 'bottom',
      borderBottom: 0,
    },
    tblHeadCellWidth100: {
      textAlign: 'center',
      verticalAlign: 'bottom',
      borderBottom: 0,
      width: 100
    },
    tblHeadCellRightWidth100: {
      textAlign: 'right',
      verticalAlign: 'bottom',
      borderBottom: 0,
      width: 100
    },
    tblHeadRow2: {
      height: 24,
    },
    tblHeadCell2: {
      textAlign: 'center',
      verticalAlign: 'top',
    },
    tblHeadCellRight2: {
      textAlign: 'right',
      verticalAlign: 'top',
    },
    tblHeadRow3: {
      height: 32,
    },
    tblCellWidth100: {
      width: 100,
    },
    tblCellPositive: {
      textAlign: 'right',
      color: '#006400'
    },
    tblCellNegative: {
      textAlign: 'right',
      color: 'red'
    },
    appnameitem: {
      marginLeft: 8,
    },
    [theme.breakpoints.up('sm')]: {
      tblCellDateCol: {
        paddingLeft: 10,
        paddingRight: 10,
        width: 50,
      },
      tblCellAppCol: {
        paddingLeft: 10,
        paddingRight: 10,
        minWidth: 200,
        width: 250,
      }
    },
    [theme.breakpoints.up('xs')]: {
      tblCellDateCol: {

      },
      tblCellAppCol: {

      }
    },

});

class TopupsList extends React.Component {
 
  render() {
    const classes = this.props.classes;
    const thenodes = this.props.cl.nodes;

    let keyCounter = 1;
    return (
      <div className={classes.paper}>
        <TableContainer>
          <Table>
            <TableHead className={classes.tblHead}>
              <TableRow className={classes.tblHeadRow}>
                <TableCell className={classes.tblHeadCellRight}>Date</TableCell>
                <TableCell className={classes.tblHeadCellRight}>Amount</TableCell>
                <TableCell>Funding</TableCell>
                <TableCell>Account</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              { thenodes.map(n => {
                let tdate = format(new Date(n.transactionTime), 'yyyy-MM-dd');
                let amount = Number(n.receivedAmount)
                          .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                let psType = n.psType;
                let ccBrand = n.ccBrand;
                let ccLast4 = n.ccLast4;
                let achAccountNum = n.achAccountNum;
                let account = '';

                if (psType === 0) {
                  if (ccBrand === 'American Express') {
                    account = 'Amex ****' + ccLast4; 
                  } else {
                    account = ccBrand + ' ****' + ccLast4; 
                  }
                  
                } else if (this.props.psType === 1) {
                  
                 if (achAccountNum != null) {  
                  account = achAccountNum;
                  } else {
                    account = '****';
                  }
          
                 }

               let theKey = n.transactionTime + '-' + keyCounter++;
               return (
                  <TableRow key={theKey}>
                    <TableCell style={{whiteSpace: 'nowrap'}} className={classes.tblCellDateCol}>{tdate}</TableCell>
                    <TableCell align="right">{amount}</TableCell>

                    {psType === 0 && ccBrand === 'MasterCard' &&
                    <TableCell><img alt="MasterCard" height="48px" style={{float: 'left'}} src={'/cards/mc-logo.png'} /></TableCell>}
                    {psType === 0 && ccBrand === 'Visa' &&
                    <TableCell ><img alt="Visa" height="36px" style={{float: 'left'}} src={'/cards/visa-logo.png'} /></TableCell>}
                    {psType === 0 && ccBrand === 'American Express' &&
                    <TableCell><img alt="AmericanExpress" height="39px" style={{float: 'left'}} src={'/cards/amex-logo.png'} /></TableCell>}
                    {psType === 0 && ccBrand === 'Discover' &&
                    <TableCell><img alt="Discover" height="36px" style={{float: 'left'}} src={'/cards/discover-logo.png'} /></TableCell>}
                    {psType === 1 &&
                    <TableCell><img alt="ACH" height="48px" style={{float: 'left'}} src={'/ach.png'} /></TableCell>}

                    <TableCell>{account}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  } // end render()
}

TopupsList.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default createFragmentContainer(withStyles(styleSheet)(TopupsList), { cl: graphql`
  fragment TopupsList_cl on AccountPaymentTsConnection {
    nodes {
      transactionTime
      receivedAmount
      psType
      ccBrand
      ccLast4
      achAccountNum
    }
  }
`});
